/**
 *
 * @param seconds Time in seconds
 * @returns Time string in format 12h:12m:12s
 */
export const getSecondsAsHMS = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor((seconds % 3600) % 60);

  const hDisplay = hours > 0 ? `${hours}h:` : "";
  // Minutes are always shown after hours, even when 0 (e.g. 1h:0m:5s)
  const mDisplay = hours > 0 || minutes > 0 ? `${minutes}m:` : "";
  const sDisplay = `${secs}s`;

  return hDisplay + mDisplay + sDisplay;
};
